/* import __COLOCATED_TEMPLATE__ from './segmented-control-button.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Args {
  value: string;
  onSelectionChange: (value: string) => void;
  selectedValue: string;
  label: string;
  icon?: InterfaceIconName;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
  Blocks: {
    default: [];
  };
}

const SegmentedControlButton = templateOnlyComponent<Signature>();
export default SegmentedControlButton;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinReadiness::SegmentedControlButton': typeof SegmentedControlButton;
    'reporting/automation/ai-insights/fin-readiness/segmented-control-button': typeof SegmentedControlButton;
  }
}
